module.exports = "/assets/data/9ed5b833075a2d48c2aed46e3360bce7-SA32.data.json";